
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { MigrationPointerModel } from 'models/generated/Distribution.Api.Models.Migration.MigrationPointer';


const _distribution_MigrationPointerControllerHelper = new Map<string, Object>();
_distribution_MigrationPointerControllerHelper.set('GetMigrationPointers', MigrationPointerModel);


export const distribution_MigrationPointerControllerHelper = _distribution_MigrationPointerControllerHelper;

